import { render, staticRenderFns } from "./TimeZoneIcon.vue?vue&type=template&id=227d078c"
import script from "./TimeZoneIcon.vue?vue&type=script&lang=js"
export * from "./TimeZoneIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports